





















































import { Component, Vue } from 'vue-property-decorator';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import axios from '../services/axios';
import '../../node_modules/swiper/swiper.min.css';
// import 'swiper/css/swiper.css';

@Component({
  components: {
    Swiper,
    SwiperSlide
  }
})
export default class PreviousWorks extends Vue {
  public preview: string = 'image';
  private previewSwiperOption = {
    loop: false,
    autoplay: false,
    slidesPerView: 'auto',
    spaceBetween: 3,
    navigation: {
      nextEl: '.preswiper-button-next',
      prevEl: '.preswiper-button-prev'
    },
    on: {
      click: function() {
        // if (this.clickedSlide.children[0].childElementCount > 0) {
        //   self.contentType = 'video';
        //   const vid = this.clickedSlide.children[0].children[0].getAttribute('data-vid');
        //   self.activeContent = vid;
        // } else {
        //   self.contentType = 'image';
        //   self.activeContent = this.clickedSlide.children[0].src;
        // }
        // this.activeIndex = this.clickedIndex;
      }
    }
  };
  private changeSlide(index: number, type: string, activeContent: string) {
    const children = (this.$refs.swiper as any).children[0].children[0].children;
    for (let i = 0; i < children.length; i ++) {
      children[i].className = children[i].className.replace(' swiper-slide-active', '');
      if (i === index) {
        children[i].className = children[i].className + ' swiper-slide-active';
      }
    }
    this.preview = type;
    this.activeContent = activeContent;
  }

  private works: any = {};
  private activeContent: string = '';

  async getWorks(id: number) {
    const { data } = await axios.get(`/mobile/awards2021/${id}`);
    if (data.code === 0) {
      this.works = data.data;
      if (this.works.vid) {
        this.preview = 'video';
        this.activeContent = this.works.vid;
      }
      if (!this.works.vid && this.works.snapshots.length > 0) {
        this.preview = 'image';
        this.activeContent = this.works.snapshots[0]['url'];
      }
    }
  }

  mounted() {
    let id = this.$route.query.id;
    if (!id) {
      return;
    }
    this.getWorks(Number(id));
  }
}
